import { ExpenseCategoryIcons } from '../utils/expenses';
import {
  ExpenseSubmitData,
  PaymentConfigCategory,
  PaymentConfigSubcategory,
} from './paymentConfig';

export interface BucketedReward {
  id: string;
  link: string;
  amount: number;
  currency: string;
}

export interface SavePaymentSubmissionResponse {
  success: boolean;
}

export interface PaymentSubmission {
  id: string;
  paymentSubcategory: string;
  paymentCategory: string;
  status: number;
  updatedAt: string;
  processorRewardLink: string;
  statusUpdatedDate: string;
  submitDate: string;
  amount: string;
  expenseCategoryName?: keyof typeof ExpenseCategoryIcons;
  expenseCategoryNameTranslation?: string;
  currency: string;
}

export type GetPaymentSubmissionsResponse = {
  requestList: PaymentSubmission[];
};

export type ProcessPatientRequestsResponse = string;

export interface IPaymentSubmissionsContext {
  isSavingSubmission: boolean;
  expenses: ExpenseSubmitData[];
  selectedPaymentCategory: PaymentConfigCategory | null;
  selectedPaymentSubcategory: PaymentConfigSubcategory | null;
  save(
    protocolId: string,
    paymentCategory: PaymentConfigCategory,
    paymentSubcategory: PaymentConfigSubcategory,
    expenses: ExpenseSubmitData[]
  ): Promise<SavePaymentSubmissionResponse[]>;
  getAll(patientId: string): Promise<PaymentSubmission[]>;
  addExpense: (expense: ExpenseSubmitData) => void;
  resetExpenses: () => void;
  setSelectedPaymentCategory: (value: PaymentConfigCategory | null) => void;
  setSelectedPaymentSubcategory: (
    value: PaymentConfigSubcategory | null
  ) => void;
  getAllReclaimRewards: () => Promise<BucketedReward[]>;
  setIsSavingSubmission: (value: boolean) => void;
}

export enum PaymentSubmissionStatus {
  Approved = 'Approved',
  InProcess = 'InProcess',
  Failed = 'Failed',
  Denied = 'Denied',
  Paid = 'Paid',
}

export const SubmissionPaidStatus = 6;
export const SubmissionApprovedStatus = 2;
export const SubmissionInProgressStatus = [1, 7];

export const getStatusData = (status: number) => {
  switch (status) {
    case 1:
    case 7:
      return {
        label: 'Requested',
        key: 'requested',
      };
    case 2:
      return {
        label: 'Approved',
        key: 'approved',
      };
    case 3:
    case 8:
      return {
        label: 'Denied',
        key: 'denied',
      };
    case 4:
      return {
        label: 'Cancelled',
        key: 'cancelled',
      };
    case 5:
      return {
        label: 'Failed',
        key: 'failed',
      };
    case 6:
      return {
        label: 'Paid',
        key: 'claimed',
      };
    default:
      return {
        label: 'In Process',
        key: 'inprocess',
      };
  }
};
